import { render, staticRenderFns } from "./RegistrationFilter.vue?vue&type=template&id=c68e8760&scoped=true"
import script from "./RegistrationFilter.vue?vue&type=script&lang=js"
export * from "./RegistrationFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68e8760",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c68e8760')) {
      api.createRecord('c68e8760', component.options)
    } else {
      api.reload('c68e8760', component.options)
    }
    module.hot.accept("./RegistrationFilter.vue?vue&type=template&id=c68e8760&scoped=true", function () {
      api.rerender('c68e8760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/filters/RegistrationFilter.vue"
export default component.exports